import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const categoryImages: Record<string, string> = {
  movie: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20clapperboard%20on%20dark%20warm%20background%2C%20golden%20spotlight%2C%20elegant%20cinema%20aesthetic%2C%20classic%20movie%20theme%20with%20warm%20amber%20tones&width=600&height=750&seq=cat-movie&orientation=portrait',
  tv: 'https://readdy.ai/api/search-image?query=Vintage%20television%20set%20with%20warm%20glow%20in%20cozy%20living%20room%2C%20retro%20aesthetic%2C%20soft%20ambient%20lighting%2C%20nostalgic%20TV%20drama%20atmosphere%20with%20golden%20tones&width=600&height=750&seq=cat-tv&orientation=portrait',
  variety: 'https://readdy.ai/api/search-image?query=Colorful%20stage%20with%20bright%20spotlights%20and%20microphone%2C%20concert%20performance%20atmosphere%2C%20warm%20vibrant%20lighting%2C%20entertainment%20show%20theme%20with%20golden%20beams&width=600&height=750&seq=cat-variety&orientation=portrait',
  anime: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20with%20vibrant%20colors%2C%20manga%20panels%2C%20creative%20Japanese%20animation%20aesthetic%2C%20warm%20and%20playful%20atmosphere%20with%20soft%20lighting&width=600&height=750&seq=cat-anime&orientation=portrait',
};

export default function CategoryNav() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            无论你喜欢哪种类型的影视内容，都能在这里找到心仪的作品
          </p>
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center inline-block mr-1.5">
                <i className={`${cat.icon} text-sm`}></i>
              </span>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {categories.filter(c => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden aspect-[4/5] cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <img
                src={categoryImages[cat.slug]}
                alt={cat.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="w-10 h-10 flex items-center justify-center mb-2">
                  <i className={`${cat.icon} text-2xl text-primary-300`}></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-background-50">{cat.name}</h3>
                <p className="text-xs text-background-300 mt-1">
                  海量{cat.name}资源持续更新
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}